<template>
  <div class="plan-estudio-container">
    <CardIeaAppMain colorCard="transparent" title="" class="premium-wrapper">
      <v-col cols="12" class="pa-0">

        <div class="hero-header glass-panel mb-4 py-3 px-6 mx-2 mx-sm-4 mt-4">
          <div class="d-flex align-center justify-space-between w-100 flex-wrap">
            <div class="d-flex align-center mb-2 mb-md-0">
              <v-btn icon dark color="primary" class="mr-4 glass-btn" @click="$router.go(-1)">
                <v-icon>mdi-arrow-left</v-icon>
              </v-btn>
              <div>
                <h1 class="text-h5 font-weight-bold primary-text mb-0">Plan de Estudio</h1>
                <p class="text-caption grey--text text--darken-1 mb-0">Todas las materias de tu carrera y en qué estado está cada una</p>
              </div>
            </div>
            <v-icon size="48" color="primary" class="opacity-30 d-none d-sm-block">mdi-school-outline</v-icon>
          </div>
        </div>

        <div v-if="cargando" class="d-flex justify-center py-10">
          <v-progress-circular indeterminate color="primary"></v-progress-circular>
        </div>

        <div v-else-if="cursos.length === 0" class="text-center grey--text py-10">
          No hay un plan de estudio cargado para tus cursos.
        </div>

        <v-card v-for="curso in cursos" :key="curso.curso_id" class="glass-card rounded-xl overflow-hidden mx-4 mb-4" elevation="10">
          <div class="pa-4 pa-sm-6 bg-light">
            <div class="d-flex align-center flex-wrap mb-4">
              <h2 class="text-h6 font-weight-bold primary-text mb-0 mr-4">{{ curso.curso }}</h2>
              <span class="text-caption grey--text">
                {{ resumen(curso).aprobada }} aprobadas · {{ resumen(curso).cursando }} cursando · {{ resumen(curso).pendiente }} pendientes
              </span>
            </div>

            <div v-for="grupo in porAno(curso.materias)" :key="grupo.ano" class="mb-4">
              <div class="text-subtitle-2 font-weight-bold primary-text mb-2">{{ grupo.ano }}</div>
              <v-row dense>
                <v-col cols="12" sm="6" md="4" v-for="m in grupo.materias" :key="m.id">
                  <v-card class="rounded-lg border-light bg-white h-100" elevation="0">
                    <div class="pa-3 d-flex align-center">
                      <v-icon :color="ESTADOS[m.estado].color" class="mr-3">{{ ESTADOS[m.estado].icon }}</v-icon>
                      <div class="flex-grow-1">
                        <div class="text-body-2 font-weight-bold primary-text">{{ m.materia }}</div>
                        <div class="text-caption grey--text">
                          <span v-if="m.cuatrimestre">{{ m.cuatrimestre }} · </span>
                          <span v-if="m.sin_elegir">Optativa sin elegir</span>
                          <span v-else>{{ ESTADOS[m.estado].texto }}<span v-if="m.nota"> · Nota {{ m.nota }}</span></span>
                        </div>
                      </div>
                    </div>
                  </v-card>
                </v-col>
              </v-row>
            </div>
          </div>
        </v-card>
      </v-col>
    </CardIeaAppMain>
  </div>
</template>
<script>
import CardIeaAppMain from "../../components/CardIeaAppMain";

// #404 (pedido del Consejo Federal): plan de estudio completo con el estado de cada materia.
const ESTADOS = {
  aprobada: { texto: "Aprobada", color: "success", icon: "mdi-check-circle-outline" },
  cursando: { texto: "Cursando", color: "primary", icon: "mdi-book-open-variant" },
  pendiente: { texto: "Pendiente", color: "warning", icon: "mdi-book-clock-outline" }
};

export default {
  name: "PlanEstudio",
  components: { CardIeaAppMain },
  data() {
    return { cursos: [], cargando: true, ESTADOS };
  },
  methods: {
    resumen(curso) {
      return curso.materias.reduce((acc, m) => ({ ...acc, [m.estado]: acc[m.estado] + 1 }),
        { aprobada: 0, cursando: 0, pendiente: 0 });
    },
    // Agrupa por año ("1ero", "2do"...) en orden numérico; las que no tienen año van al final.
    porAno(materias) {
      const grupos = {};
      materias.forEach(m => {
        const ano = m.ano ? m.ano + " año" : "Sin año asignado";
        (grupos[ano] = grupos[ano] || []).push(m);
      });
      return Object.keys(grupos)
        .sort((a, b) => (parseInt(a) || 99) - (parseInt(b) || 99))
        .map(ano => ({ ano, materias: grupos[ano] }));
    }
  },
  mounted() {
    this.$API
      .get({ url: "plan-estudio-alumno", data: {} })
      .then(res => {
        this.cursos = Array.isArray(res) ? res : [];
      })
      .finally(() => {
        this.cargando = false;
      });
  }
};
</script>

<style scoped>
.plan-estudio-container { background: transparent !important; min-height: calc(100vh - 120px); }
.glass-panel { background: rgba(255, 255, 255, 0.7) !important; backdrop-filter: blur(16px) !important; border: 1px solid rgba(255, 255, 255, 0.5) !important; box-shadow: 0 8px 32px 0 rgba(31, 38, 135, 0.05) !important; border-radius: 20px; padding: 24px; }
.glass-card { background: rgba(255, 255, 255, 0.85) !important; backdrop-filter: blur(16px) !important; border: 1px solid rgba(255, 255, 255, 0.4) !important; }
.glass-btn { background: rgba(25, 118, 210, 0.1) !important; box-shadow: none !important; }
.bg-light { background-color: #f8fafc !important; }
.border-light { border: 1px solid rgba(0, 0, 0, 0.05) !important; }
.primary-text { color: #1e293b; }
.opacity-30 { opacity: 0.3; }
.w-100 { width: 100%; }
</style>
